namespace $ {
	try {
		$mol_offline()
	} catch( error ) {
		console.error( error )
	}
}
